module.exports = __webpack_public_path__ + "img/check-white.e5f4faa4.svg";